import { ICoherenceHeaderProps } from '@cseo/controls/lib/header';
import { EmployeeFilter } from '../Pages/TAR/TimeEntry/Filter/EmployeeFilter';
import * as React from 'react';
import { HelpPanel } from '../Shared/HelpPanel/HelpPanel';
import * as Styled from './HeaderConfig.styled';

export function HeaderConfig(): ICoherenceHeaderProps {
    return {
        headerLabel: __APP_NAME__,
        appNameSettings: {
            label: <Styled.AppNameHeading>{__APP_NAME__}</Styled.AppNameHeading>,
            ariaLabel: __APP_NAME__
        },
        searchSettings: {
            onSearch: (): void => {},
            placeholder: 'Please enter the emailname',
            onRender: function employeeSearch(): JSX.Element {
                return <EmployeeFilter />;
            }
        },
        farRightSettings: {
            helpSettings: {
                panelSettings: {
                    body: <HelpPanel />
                }
            },
            profileSettings: {
                panelSettings: {
                    fullName: undefined,
                    emailAddress: undefined,
                    imageUrl: undefined,
                    logOutLink: '',
                    hideSignOutDivider: true
                }
            }
        }
    };
}
